<template>
    <!-- Modal -->
    <div class="modal fade" id="updateWithdrawal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header pb-1">
                    <h5 class="modal-title font-weight-bold">{{ __('transactions.Edit Withdrawal') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body py-0">

                    <div class="py-5 text-center" v-show="loading">
                        <span class="spinner-border" role="status" aria-hidden="true"></span>
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="save" novalidate="true" v-show="!loading">

                        <!-- Date -->
                        <div class="form-group">
                            <label>{{ __('transactions.Date') }} *</label>

                            <b-form-datepicker
                                v-model="form.date"
                                :class="{ 'is-invalid': form.errors.has('date') }"
                                :locale="locale"
                                placeholder=""
                                :disabled="disabled">
                            </b-form-datepicker>

                            <has-error :form="form" field="date"></has-error>
                        </div>

                        <!-- Value -->
                        <div class="form-group">
                            <label class="">{{ __('transactions.Value') }} *</label>

                            <currency-input
                                :locale="locale"
                                :currency='currency'
                                class="form-control font-weight-bold"
                                v-bind:class="{'is-invalid': form.errors.has('value')}"
                                v-model="form.value"
                            />

                            <has-error :form="form" field="value"></has-error>
                        </div>

                        <!-- Description -->
                        <div class="form-group mb-0">
                            <label class="">{{ __('transactions.Description') }}</label>

                            <textarea class="form-control" v-model="form.description" :class="{ 'is-invalid': form.errors.has('description') }">
                            </textarea>

                            <has-error :form="form" field="description"></has-error>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{ __('transactions.Close') }}</button>

                    <button type="button" class="btn btn-primary" @click="save" :disabled="form.busy">
                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="form.busy"></span>
                        <span v-if="!form.busy">{{ __('transactions.Save') }}</span>
                        <span v-if="form.busy">{{ __('transactions.Saving') }} ...</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form } from 'vform'

    export default {
        props: ['locale', 'currency'],
        data() {
            return {
                loading: false,
                disabled: false,
                itemId: null,
                form: new Form({
                    date: null,
                    value: null,
                    description: null,
                }),
            }
        },
        mounted() {
            // Triggered when modal open
            $('#updateWithdrawal').on('show.bs.modal', (e) => {
                this.itemId = $(e.relatedTarget).data('withdrawal-id');
                this.getInfo()
            });
        },
        methods: {

            getInfo() {
                this.loading = true;
                axios.get('/transactions/withdrawal/' + this.itemId)
                    .then((result) => {
                        this.form.date = result.date;
                        this.form.value = result.value;
                        this.form.description = result.description;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                    })
            },

            save() {
                this.form.put('/transactions/withdrawal/' + this.itemId)
                    .then(result => {
                        if (result.redirect) {
                            window.location = result.redirect
                        }
                    })
            },

        }
    }
</script>

<style>

</style>
